(function(){
  var $=function(s,r){return (r||document).querySelector(s)};
  var t=$('[data-menu-toggle]'),m=$('#side-nav');
  if(t&&m)t.addEventListener('click',function(){
    var open=!m.classList.contains('is-open');m.classList.toggle('is-open',open);t.setAttribute('aria-expanded',open);t.textContent=open?'CLOSE':'MENU';
  });
  var ah=$('[data-announcement-hide]');if(ah)ah.addEventListener('click',function(){$('[data-announcement]').classList.add('is-hidden')});
  var sb=$('[data-search-bar]'),so=$('[data-search-open]'),sc=$('[data-search-close]');
  if(sb&&so){
    so.addEventListener('click',function(e){e.preventDefault();sb.hidden=false;$('input',sb).focus()});
    sc.addEventListener('click',function(){sb.hidden=true});
  }
  var g=$('[data-gallery]'),bar=$('[data-gallery-bar] i');
  if(g&&bar){
    var n=g.children.length;bar.style.width=(100/n)+'%';
    g.addEventListener('scroll',function(){bar.style.left=(g.scrollLeft/g.scrollWidth*100)+'%'},{passive:true});
  }
  var acc=$('[data-acc-main]');if(acc&&window.matchMedia('(max-width:900px)').matches)acc.removeAttribute('open');
  var form=$('#product-form');
  if(form){
    var variants=JSON.parse($('[data-variants]',form)?$('[data-variants]',form).textContent:'[]');
    var money=function(c){return '$'+(c/100).toFixed(2)};
    var refresh=function(){
      var sets=form.querySelectorAll('.opt');
      var sel=[].map.call(sets,function(f){var c=f.querySelector('input:checked');return c&&c.value});
      sets.forEach(function(f,i){f.querySelectorAll('input').forEach(function(inp){
        var ok=variants.some(function(v){return v.available&&v.options[i]===inp.value&&v.options.every(function(o,j){return j===i||o===sel[j]})});
        var l=f.querySelector('label[for="'+inp.id+'"]');if(l)l.classList.toggle('oos',!ok);
      })});
    };
    refresh();
    form.addEventListener('change',function(){refresh();
      var sel=[].map.call(form.querySelectorAll('.opt'),function(f){var c=f.querySelector('input:checked');return c&&c.value});
      var v=variants.find(function(v){return v.options.every(function(o,i){return o===sel[i]})});
      var btn=$('[data-add]',form);
      if(!v){btn.disabled=true;btn.textContent='UNAVAILABLE';return}
      $('[data-variant-id]',form).value=v.id;
      btn.disabled=!v.available;btn.textContent=v.available?'ADD TO BAG':'SOLD OUT';
      $('[data-price]').textContent=money(v.price);
      history.replaceState(null,'','?variant='+v.id);
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:$('[data-variant-id]',form).value,quantity:1})})
        .then(function(r){if(!r.ok)throw 0;return fetch('/cart.js')}).then(function(r){return r.json()})
        .then(function(c){var n=$('[data-cart-count-wrap]');if(n)n.textContent=' ('+c.item_count+')'})
        .catch(function(){window.location.href='/cart'});
    });
  }
})();
